import "../i18n"
import "font/font.css"

import IgniteApp from "@ignite/react/App"
import React from "react"

const App = () => <IgniteApp />

export default App
